module.exports = __webpack_public_path__ + "img/framework.1a6ccd19.png";